import { readDayAheadBidValue } from './bidValue.helper'

export function readDayAheadBidName(rawValue: string | undefined): string | null {
  const name = rawValue?.trim() ?? ''
  return name === '' ? null : name
}

export function holdsDayAheadBidContent(cell: 'name' | 'price', rawValue: string | undefined): boolean {
  return cell === 'name' ? readDayAheadBidName(rawValue) !== null : readDayAheadBidValue(rawValue).kind === 'value'
}

type DayAheadBidColumnCells = {
  name: string | undefined
  price: string | undefined
  hourVolumes: string[]
}

export function findDayAheadBidContentWithoutVolume({
  name,
  price,
  hourVolumes,
}: DayAheadBidColumnCells): 'name' | 'price' | undefined {
  if (hourVolumes.some((volume) => readDayAheadBidValue(volume).kind !== 'blank')) {
    return undefined
  }
  if (holdsDayAheadBidContent('name', name)) {
    return 'name'
  }
  return holdsDayAheadBidContent('price', price) ? 'price' : undefined
}
